export const SETTINGS_REQUEST = "SETTINGS_REQUEST";
export const SETTINGS_SUCCESS = "SETTINGS_SUCCESS";
export const SETTINGS_ERROR = "SETTINGS_ERROR";

export const UPLOAD_LOGO_REQUEST = "UPLOAD_LOGO_REQUEST";
export const UPLOAD_LOGO_SUCCESS = "UPLOAD_LOGO_SUCCESS";
export const UPLOAD_LOGO_ERROR = "UPLOAD_LOGO_ERROR";

export const UPLOAD_LOGIN_DIALOG_IMAGE_REQUEST = "UPLOAD_LOGIN_DIALOG_IMAGE_REQUEST";
export const UPLOAD_LOGIN_DIALOG_IMAGE_SUCCESS = "UPLOAD_LOGIN_DIALOG_IMAGE_SUCCESS";
export const UPLOAD_LOGIN_DIALOG_IMAGE_ERROR = "UPLOAD_LOGIN_DIALOG_IMAGE_ERROR";

export const UPLOAD_HERO_SLIDERS_REQUEST = "UPLOAD_HERO_SLIDERS_REQUEST";
export const UPLOAD_HERO_SLIDERS_SUCCESS = "UPLOAD_HERO_SLIDERS_SUCCESS";
export const UPLOAD_HERO_SLIDERS_ERROR = "UPLOAD_HERO_SLIDERS_ERROR";

export const DELETE_HERO_SLIDER_REQUEST = "DELETE_HERO_SLIDER_REQUEST";
export const DELETE_HERO_SLIDER_SUCCESS = "DELETE_HERO_SLIDER_SUCCESS";
export const DELETE_HERO_SLIDER_ERROR = "DELETE_HERO_SLIDER_ERROR";

export const UPDATE_SETTINGS_REQUEST = "UPDATE_SETTINGS_REQUEST";
export const UPDATE_SETTINGS_SUCCESS = "UPDATE_SETTINGS_SUCCESS";
export const UPDATE_SETTINGS_ERROR = "UPDATE_SETTINGS_ERROR";


